export enum UserState {
  Invited = 'INVITED',
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Requested = 'REQUESTED',
}

/**
 * The states a person may enter the site in - anything else means somebody deliberately took them off it.
 * Mirrors `SupplierEmployeeState.ENTERABLE` on the backend.
 */
export const ENTERABLE_USER_STATES: UserState[] = [UserState.Active, UserState.Invited];

/**
 * The states a supplier employee may be moved to from each state (the current state itself not included).
 * Mirrors the backend's allowed transitions - anything else is rejected with "Invalid state transition requested".
 */
export const SUPPLIER_EMPLOYEE_STATE_TRANSITIONS: Record<UserState, UserState[]> = {
  [UserState.Invited]: [UserState.Inactive],
  [UserState.Active]: [UserState.Inactive],
  [UserState.Inactive]: [UserState.Active],
  [UserState.Requested]: [UserState.Active, UserState.Inactive],
};
